import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BrandHeader from './components/BrandHeader';
import WinesSection from './components/WinesSection';
import VinegarSection from './components/VinegarSection';
import JuiceSection from './components/JuiceSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <main>
        <BrandHeader />
        <WinesSection />
        <VinegarSection />
        <JuiceSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
